<!-- Hiển thị thông tin chi tiết nhân viên, thnhat 15/3/2022-->
<template>
  <div
    class="wrap-text w-full"
    :class="{'detail-info': isLimitText}"
    :title="getDetailInfo()"
  >
    {{ getDetailInfo() }}
  </div>
</template>

<script>


export default {
  name:"DisplayEmployeeDetail",

  props: {
    employee:{
        type: Object,
        default :() => {}
    },

    // Có giới hạn độ dài thông tin không
    isLimitText:{
        type: Boolean,
        default: false
    }
  },
  methods:{
    // lấy thông tin chi tiết để show ra
    getDetailInfo(){
        let detailInfo = '';
        if(this.employee.JobTitleName) detailInfo += this.employee.JobTitleName
        if(this.employee.OrganizationUnitName) {
            if(this.employee.JobTitleName) detailInfo += ' - '
            detailInfo += this.employee.OrganizationUnitName
        }
        if(this.employee.OrganizationName) {
            if (this.employee.OrganizationName.toLowerCase() !== this.employee.OrganizationUnitName?.toLowerCase()) {
              if(this.employee.JobTitleName || this.employee.OrganizationUnitName) detailInfo += ' - '
              detailInfo += this.employee.OrganizationName
            }
        }
        return detailInfo
    }
  }

};
</script>

<style lang="scss" scoped>
.detail-info{
    max-width: 100%;
}
</style>